<template>
  <div class="growth_as_an_engineer">
    <PageHeader
    :image="require('../assets/growth_as_an_engineer/title.svg')"
    :imageSp="require('../assets/growth_as_an_engineer/title.svg')"
    alt="growth as an engineer"
    headCatch="高い技術力を持った<br>
          プロフェッショナルの集団に。"
    intro="豆蔵という会社の核となるもの。<br>
        それは「高い技術力」に他なりません。<br>
        経営陣の技術力に対するコミットメントや<br>
        技術者として成長できる「5つの理由」について紹介します。<br>
        <br>
        入社後に急速に成長できる環境が、ここにはあります。"
    />
    <GrowthArticle/>
  </div>
</template>
<script>
// @ is an alias to /src
import PageHeader from '@/components/mainpage/PageHeader.vue';
import GrowthArticle from '@/components/mainpage/GrowthArticle.vue';
export default {
  name: 'growth_as_an_engineer',
  components: {
    PageHeader,
    GrowthArticle
  },
}
</script>

<style lang="scss" scoped>
.growth_as_an_engineer {
  position: relative;
  overflow: hidden;
  width: 100%;
}
</style>
